import { HttpHeaders } from '@angular/common/http';
import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';
import isEmpty from 'lodash-es/isEmpty';
import { Observable, of } from 'rxjs';
import { catchError, concatAll, distinctUntilChanged, filter, switchMap } from 'rxjs/operators';
import { oc } from 'ts-optchain';
import { headersAllTenantsAppend } from '../../../classes/utils/utils';
import { ConsumerApi, SignatureApi } from '../../../sdk';

@Pipe({
  name: 'signatureLink',
})
export class SignatureLinkPipe implements PipeTransform {
  constructor(
    private consumerApi: ConsumerApi,
    private signatureApi: SignatureApi,
  ) {}

  transform(id: number | string, type: 'CONS' | 'SIGN' | 'FILE', convert?: string): Observable<string> {
    if (isNil(id) || isEmpty('' + id)) return of('');

    function customHeaders(headers: HttpHeaders) {
      return headersAllTenantsAppend(headers).append('ngsw-bypass', '1');
    }

    const c$ = _id => this.consumerApi.getSignMediaLink(_id, convert, customHeaders);
    const s$ = _id => this.signatureApi.getSignLink(_id, convert, customHeaders);
    const i$ = _id => this.signatureApi.getLink(_id, convert, customHeaders);

    const oMap = {
      CONS: c$,
      SIGN: s$,
      FILE: i$,
    };

    return of(id).pipe(
      filter(_id => !isEmpty(oc(_id)(''))),
      distinctUntilChanged(),
      // tap(console.log),
      switchMap(_id =>
        of(
          of('/assets/images/loader.gif'),
          oMap[type](_id).pipe(catchError(err => of('/assets/images/none.png'))),
        ).pipe(concatAll()),
      ),
    );
  }
}
